import { useCallback, useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import Sidebar from "../component/Sidebar";
import Topbar from "../component/Topbar";
import Footer from "../component/Footer";
import CommonTable from "../component/CommonTable";
import axios from "axios";
import { BASE_URL } from "../api";
import MessageToster from "../component/MessageToster";
import Loader from "../component/Loader";
import { closeModal } from "../utils/modal";
import { getApiHeaders } from "../utils/helpers";
import { useHandleError } from "../hooks/useHandleError";
import { exportToExcel } from "../utils/exportData";
import { formatDateDDMMYYYY } from "../utils/dateUtils";
import ExportButton from "../component/ExportButton";
import MobileFilter from "../component/MobileFilter";

export default function Demoaccount() {
  const tableRef = useRef();
  const handleError = useHandleError();
  const [accountData, setAccountData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [accountType, setAccountType] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [filters, setFilters] = useState({
    fromDate: "",
    toDate: "",
  });

  const clearFilters = () => {
    setFilters({
      fromDate: "",
      toDate: "",
    });
    setSearchTerm("");
    setFilteredData(accountData);
  };
  // const [accountType, setAccountType] = useState();
  const [loading, setLoading] = useState(false);
  // const [verror, setVerror] = useState('');
  const [input, setInput] = useState({
    platform: "",
    account_group: "",
    leverage: "",
    balance: ""
  })
  const [errors, setErrors] = useState({
    platform: "",
    account_group: "",
    leverage: "",
    balance: ""
  });
  // const validationRules = {
  //   platform: "Platform is required.",
  //   account_group: "Account type is required.",
  //   leverage: "Leverage is required.",
  //   balance: "Minimum 100 balance is required."
  // };

  const handelChange = (e) => {
    const { name, value } = e.target;
    setInput(prev => ({ ...prev, [name]: value }));

    let errorMsg = "";

    if (name === "balance" && value !== "") {
      const numVal = Number(value);
      if (isNaN(numVal)) {
        errorMsg = "Please enter a valid balance.";
      } else if (numVal < 100) {
        errorMsg = "Minimum 100 balance is required.";
      } else if (numVal > 10000000) {
        errorMsg = "Maximum 10000000 balance is allowed.";
      }
    }

    setErrors(prev => ({ ...prev, [name]: errorMsg }));
  };

  const handleReset = () => {
    setInput({
      platform: "",
      account_group: "",
      leverage: "",
      balance: ""
    });

    setErrors({
      platform: "",
      account_group: "",
      leverage: "",
      balance: ""
    });
  };

  const onSubmitForm = async () => {
    const newErrors = {};

    if (!input.platform) newErrors.platform = "Platform is required.";
    if (!input.account_group) newErrors.account_group = "Account type is required.";
    if (!input.leverage) newErrors.leverage = "Leverage is required.";

    if (!input.balance) {
      newErrors.balance = "Balance is required.";
    } else {
      const numBalance = Number(input.balance);
      if (isNaN(numBalance)) {
        newErrors.balance = "Please enter a valid balance.";
      } else if (numBalance < 100) {
        newErrors.balance = "Minimum 100 balance is required.";
      } else if (numBalance > 10000000) {
        newErrors.balance = "Maximum 10000000 balance is allowed.";
      }
    }

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    // for (const field in input) {
    //   if (!input[field]) {
    //     setValidations(prev => ({ ...prev, [field]: true }));
    //     setVerror(validationRules[field]);
    //     return;
    //   }
    // }

    // if (Number(input.balance) < 100) {
    //   setValidations(prev => ({ ...prev, balance: true }));
    //   setVerror("Minimum 100 balance is required.");
    //   return;
    // }

    await createDemoAccount();
  }

  const createDemoAccount = async () => {
    try {
      const mid = sessionStorage.getItem("mid");

      const bodyData = {
        // mid: Number(mid),
        trading_platform: input.platform,
        currency: "USD",
        account_group: input.account_group,
        leverage: Number(input.leverage),
        balance: Number(input.balance),
        account_type: "DEMO"
      };
      setLoading(true);

      const res = await axios.post(`${BASE_URL}/MT5M/create_new_demo_account`, bodyData, { headers: getApiHeaders() });

      if (res.data.code === 200) {
        MessageToster("success", res.data.message);
        closeModal()

        handleReset();

        sessionStorage.setItem("loginid", res.data.loginid);
        getTabelData();

      } else {
        MessageToster("error", res.data.message || "Something went wrong");
      }
    } catch (error) {
      handleError(error);
    } finally {
      setLoading(false);
    }
  };


  const getTabelData = useCallback(async () => {
    setLoading(true);
    const dataofmid = sessionStorage.getItem('mid');
    // const bodyData = {
    //   mode: "",
    //   mid: dataofmid
    // };

    const bodyData = {};

    try {
      const res = await axios.get(`${BASE_URL}/MT5M/user_total_demo_account`, { headers: getApiHeaders() });

      if (res.data.code === 200) {
        setAccountData(Array.isArray(res.data.message) ? res.data.message : []);
      } else {
        setAccountData([]);
        MessageToster('error', res.data?.message || 'Failed to fetch demo accounts');
      }
    } catch (error) {
      handleError(error);
    } finally {
      setLoading(false);
    }
  }, [handleError]);

  useEffect(() => {
    setFilteredData(accountData);
  }, [accountData]);

  const handleSearch = () => {
    let data = [...accountData];
    if (filters.fromDate) {
      const from = new Date(filters.fromDate);
      from.setHours(0, 0, 0, 0);
      data = data.filter((item) => {
        const itemDateStr = item.create_date ? item.create_date.split('.')[0] : "";
        const itemDate = new Date(itemDateStr);
        return itemDate >= from;
      });
    }
    if (filters.toDate) {
      const to = new Date(filters.toDate);
      to.setHours(23, 59, 59, 999);
      data = data.filter((item) => {
        const itemDateStr = item.create_date ? item.create_date.split('.')[0] : "";
        const itemDate = new Date(itemDateStr);
        return itemDate <= to;
      });
    }
    if (searchTerm) {
      const searchLower = searchTerm.toLowerCase();
      data = data.filter((item) => {
        return (
          String(item.account_number || "").toLowerCase().includes(searchLower) ||
          String(item.account_group || "").toLowerCase().includes(searchLower) ||
          String(item.leverage || "").toLowerCase().includes(searchLower) ||
          String(item.margin_free || "").toLowerCase().includes(searchLower) ||
          String(item.balance || "").toLowerCase().includes(searchLower)
        );
      });
    }
    setFilteredData(data);
  };


  const getaccounttypes = useCallback(async () => {
    setLoading(true);
    try {
      const res = await axios.get(`${BASE_URL}/mt5/get_demo_group`, { headers: getApiHeaders() });
      if (res.data.code === 200) {
        setAccountType(res.data.data);
      } else {
        MessageToster('error', res.data.message || 'Something went wrong');
      }
    } catch (error) {
      handleError(error);
    } finally {
      setLoading(false);
    }
  }, [handleError]);

  useEffect(() => {
    getTabelData()
    getaccounttypes()
  }, [getTabelData, getaccounttypes]);

  //   return [
  //     item.account_number,
  //     item.trading_platform,
  //     item.account_group,
  //     item.currency,
  //     item.leverage,
  //     item.balance,
  //     new Date(item.create_date).toLocaleDateString(),
  //     new Date(item.expdate).toLocaleDateString(),
  //     actions
  //   ];
  // });

  const columns = [
    { header: 'Account No', accessor: 'account_number' },
    { header: 'Platform', accessor: 'trading_platform' },
    { header: 'Account Type', accessor: 'account_group' },
    { header: 'Currency', accessor: 'currency' },
    { header: 'Leverage', accessor: 'leverage' },
    { header: 'Balance', accessor: 'balance' },
    { header: 'Created Date', render: (row) => formatDateDDMMYYYY(row.create_date) },
    { header: 'Expiry Date', render: (row) => formatDateDDMMYYYY(row.expdate) },
    {
      header: 'Actions',
      headerStyle: { width: '1%', whiteSpace: 'nowrap' },
      style: { width: '1%', whiteSpace: 'nowrap' },
      render: (row) => (
        <div className="d-flex flex-row align-items-stretch align-items-md-center gap-2 w-100">
          <Link
            to={`/masterpassword?account=${row.account_number}&type=demo`}
            className="btn btn-sm btn-primary waves-effect waves-light d-inline-flex align-items-center justify-content-center gap-1 text-nowrap"
            title="Change Trading Password"
          >
            <i className="mdi mdi-key-variant font-size-13"></i>
            <span>Trading Password</span>
          </Link>
          <Link
            to={`/investorpassword?account=${row.account_number}&type=demo`}
            className="btn btn-sm btn-primary waves-effect waves-light d-inline-flex align-items-center justify-content-center gap-1 text-nowrap"
            title="Change Investor Password"
          >
            <i className="mdi mdi-shield-account font-size-13"></i>
            <span>Investor Password</span>
          </Link>
        </div>
      )
    }
  ];

  // if above is not work than use it.
  // useEffect(() => {
  //   if (accountData?.length > 0) {
  //     const rows = accountData.map(item => [
  //       item.account_number,
  //       item.trading_platform,
  //       item.account_group,
  //       item.currency,
  //       item.leverage,
  //       item.balance,
  //       new Date(item.create_date).toLocaleDateString(),
  //       new Date(item.expdate).toLocaleDateString(),
  //       `
  //     <div class="btn-group">
  //       <button type="button" class="btn btn-primary dropdown-toggle" data-bs-toggle="dropdown">
  //         Actions <i class="mdi mdi-chevron-down"></i>
  //       </button>
  //       <div class="dropdown-menu table_dropdown">
  //       <a class="dropdown-item" href="/masterpassword?account=${item.account_number}&type=demo">Change Trading Password</a>
  //         <a class="dropdown-item" href="/investorpassword?account=${item.account_number}&type=demo">Change Investor Password</a>
  //       </div>
  //     </div>
  //     `
  //     ]);

  //     displayButtons(tableRef, rows);
  //   }
  // }, [accountData]);

  return (
    <>
      <div id="layout-wrapper">
        {loading &&
          <Loader />
        }
        <Topbar />
        <Sidebar />
        <div className="main-content">
          <div className="page-content">
            <div className="container-fluid">
              {/* start page title */}
              <div className="row">
                <div className="col-12">
                  <div className="page-title-box d-flex align-items-center justify-content-between">
                    <h2 className="fw-700 mb-0">Demo Account</h2>
                    <div className="demo_account_btn">
                      <button
                        type="button"
                        className="btn btn-primary waves-effect waves-light"
                        data-bs-toggle="modal"
                        data-bs-target=".bs-example-modal-center"
                        onClick={handleReset}
                      >
                        Open Account
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              {/* end page title */}
              <div className="row">
                <div className="col-12">
                  <div className="card" style={{ minHeight: "calc(100vh - 210px)" }}>
                    <div className="card-body d-flex flex-column">
                      <div className="d-flex flex-wrap align-items-end gap-2 mb-4 desktop-filter-row">
                        <div>
                          <label htmlFor="">From</label>
                          <input
                            className="form-control"
                            type="date"
                            onKeyDown={(e) => e.preventDefault()}
                            name="fromDate"
                            value={filters.fromDate}
                            onChange={(e) => setFilters({ ...filters, fromDate: e.target.value })}
                            max={filters.toDate ? (filters.toDate > new Date().toISOString().split("T")[0] ? new Date().toISOString().split("T")[0] : filters.toDate) : new Date().toISOString().split("T")[0]}
                            id="example-date-input"
                          />
                        </div>
                        <div>
                          <label htmlFor="">To</label>
                          <input
                            className="form-control"
                            type="date"
                            onKeyDown={(e) => e.preventDefault()}
                            name="toDate"
                            value={filters.toDate}
                            onChange={(e) => setFilters({ ...filters, toDate: e.target.value })}
                            min={filters.fromDate || undefined}
                            max={new Date().toISOString().split("T")[0]}
                            id="example-date-input"
                          />
                        </div>
                        <div>
                          <label htmlFor="">Search</label>
                          <input
                            className="form-control"
                            type="text"
                            placeholder="Search..."
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                          />
                        </div>
                        <div>
                          <button
                            type="button"
                            className="btn btn-primary waves-effect waves-light"
                            onClick={handleSearch}
                            title="Search"
                          >
                            <span>Search</span>
                          </button>
                        </div>
                        <div>
                          <button
                            type="button"
                            className="btn btn-primary waves-effect waves-light"
                            onClick={clearFilters}
                            disabled={!filters.fromDate && !filters.toDate && !searchTerm}
                            title="Clear"
                          >
                            <span>Clear</span>
                          </button>
                        </div>
                        <div className="ms-auto">
                          <ExportButton
                            disabled={!filteredData || filteredData.length === 0}
                            onClick={() => exportToExcel(filteredData, "demo_account", "demo_account")}
                          />
                        </div>
                      </div>

                      <MobileFilter
                        title="History"
                        onExport={() => exportToExcel(filteredData, "demo_account", "demo_account")}
                        exportDisabled={!filteredData || filteredData.length === 0}
                      >
                        <div>
                          <label htmlFor="">From</label>
                          <input
                            className="form-control"
                            type="date"
                            onKeyDown={(e) => e.preventDefault()}
                            name="fromDate"
                            value={filters.fromDate}
                            onChange={(e) => setFilters({ ...filters, fromDate: e.target.value })}
                            max={filters.toDate ? (filters.toDate > new Date().toISOString().split("T")[0] ? new Date().toISOString().split("T")[0] : filters.toDate) : new Date().toISOString().split("T")[0]}
                          />
                        </div>
                        <div>
                          <label htmlFor="">To</label>
                          <input
                            className="form-control"
                            type="date"
                            onKeyDown={(e) => e.preventDefault()}
                            name="toDate"
                            value={filters.toDate}
                            onChange={(e) => setFilters({ ...filters, toDate: e.target.value })}
                            min={filters.fromDate || undefined}
                            max={new Date().toISOString().split("T")[0]}
                          />
                        </div>
                        <div>
                          <label htmlFor="">Search</label>
                          <input
                            className="form-control"
                            type="text"
                            placeholder="Search..."
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                          />
                        </div>
                        <div className="d-flex gap-2 mt-2">
                          <button
                            type="button"
                            className="btn btn-primary waves-effect waves-light flex-grow-1"
                            onClick={handleSearch}
                            data-bs-dismiss="offcanvas"
                            data-bs-target="#filterOffcanvasMobile"
                          >
                            Search
                          </button>
                          <button
                            type="button"
                            className="btn btn-light waves-effect waves-light border flex-grow-1"
                            onClick={clearFilters}
                            disabled={!filters.fromDate && !filters.toDate && !searchTerm}
                            data-bs-dismiss="offcanvas"
                            data-bs-target="#filterOffcanvasMobile"
                          >
                            Clear
                          </button>
                        </div>
                      </MobileFilter>

                      <CommonTable
                        columns={columns}
                        data={filteredData}
                        loading={loading}
                        className="flex-grow-1 d-flex flex-column justify-content-between"
                      />
                    </div>
                  </div>
                </div>
                {/* end col */}
                <div>
                  {/* modal */}
                  <div
                    className="modal fade bs-example-modal-center"
                    tabIndex={-1}
                    role="dialog"
                    aria-hidden="true"
                  >
                    <div className="modal-dialog modal-dialog-centered">
                      <div className="modal-content">
                        <div className="modal-header">
                          <h5 className="modal-title">Open Demo Account</h5>
                          <button
                            type="button"
                            className="btn-close"
                            data-bs-dismiss="modal"
                            aria-label="Close"
                          />
                        </div>
                        <div className="modal-body">
                          <div className="row">
                            <div className="col-12 mb-3">
                              <div>
                                <label className="form-label">
                                  Trading Plateform{" "}
                                  <span className="text-danger">*</span>
                                </label>
                                <select
                                  className="form-select"
                                  id="platform"
                                  name="platform"
                                  value={input.platform}
                                  onChange={(e) => handelChange(e)}
                                >
                                  <option value={""} disabled hidden>Select Your Trading Platform</option>
                                  <option value="MT5">MT5</option>
                                </select>
                                {errors.platform && <p className="text-danger mb-0">{errors.platform}</p>}
                                {/* {validations.platform &&
                                  verror && <>
                                    <p className='text-danger mb-0'>{verror}</p>
                                  </>
                                } */}
                              </div>
                            </div>
                            <div className="col-12 mb-3">
                              <div>
                                <label className="form-label">
                                  Account Type
                                  <span className="text-danger">*</span>
                                </label>
                                <select
                                  className="form-select"
                                  id="account_group"
                                  name="account_group"
                                  value={input.account_group}
                                  onChange={(e) => handelChange(e)}
                                >
                                  <option value={""} disabled hidden>Select account group</option>
                                  {accountType &&
                                    accountType.map((i) => (
                                      <option key={i.id} value={i.GroupName}>
                                        {i.plan_name}
                                      </option>
                                    ))}

                                </select>
                                {errors.account_group && <p className="text-danger mb-0">{errors.account_group}</p>}
                                {/* {validations.account_group &&
                                  verror && <>
                                    <p className='text-danger mb-0'>{verror}</p>
                                  </>
                                } */}
                              </div>
                            </div>
                            <div className="col-12 mb-3">
                              <div>
                                <label className="form-label">
                                  Leverage
                                  <span className="text-danger">*</span>
                                </label>
                                <select
                                  className="form-select"
                                  name="leverage"
                                  id="leverage"
                                  value={input.leverage}
                                  onChange={(e) => handelChange(e)}
                                >
                                  <option value={""} disabled hidden>Select leverage</option>
                                  <option value="100">100</option>
                                  <option value="200">200</option>
                                  <option value="300">300</option>
                                  <option value="400">400</option>
                                  <option value="500">500</option>
                                </select>
                                {errors.leverage && <p className="text-danger mb-0">{errors.leverage}</p>}
                                {/* {validations.leverage &&
                                  verror && <>
                                    <p className='text-danger mb-0'>{verror}</p>
                                  </>
                                } */}
                              </div>
                            </div>
                            <div className="col-12">
                              <div>
                                <label className="form-label">
                                  Balance <span className="text-danger">*</span>
                                </label>

                                <input
                                  type="number"
                                  className="form-control"
                                  name="balance"
                                  id="balance"
                                  placeholder="Enter Balance"
                                  value={input.balance}
                                  onChange={handelChange}
                                  min={100}
                                  max={10000000}
                                />
                                {errors.balance && <p className="text-danger mb-0">{errors.balance}</p>}
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="modal-footer">
                          <button
                            type="button"
                            className="btn btn-secondary"
                            onClick={handleReset}
                          >
                            Reset
                          </button>
                          <button type="button"
                            className="btn btn-primary"
                            // data-bs-dismiss="modal"
                            // aria-label="Close"
                            onClick={onSubmitForm}
                          >
                            Submit
                          </button>
                        </div>
                      </div>
                      {/* /.modal-content */}
                    </div>
                    {/* /.modal-dialog */}
                  </div>
                  {/* /.modal */}
                </div>
              </div>
            </div>
            {/* container-fluid */}
          </div>
          {/* End Page-content */}
          <Footer />
        </div>
      </div>
    </>
  );
}
